{
    "firebase": {
        "apiKey": "AIzaSyAdiK_7NhVwilVcQq5gEm1ZHbSyOoTIunY",
        "authDomain": "app-test-3bb21.firebaseapp.com",
        "databaseURL": "https://app-test-3bb21-default-rtdb.firebaseio.com",
        "projectId": "app-test-3bb21",
        "storageBucket": "app-test-3bb21.firebasestorage.app",
        "messagingSenderId": "849889818926",
        "appId": "1:849889818926:web:e9acc8af8a96da2b8022bf"
    },
    "clientName": "Flightline App Test",
    "pdfViewerKey": "d835afe3caeb4eee8c9f0f396e49186d",
    "domains": ["app-test.flightlinedata.com"],
    "tally_url": ""
}
